/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ActivitiesPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABgUlEQVR4nOWUO07DQBCGLV4F4gK8WjoKeiTXKJ6Hi9VMSJ+eApBoTKAgtJwAiSOAQk9Iwy14JAXiAkigICdxMMYbE5ZUjDSNd/z9s//Oruf960DUDSS5QNYnIHlH1i6QPAYsW+5wlt0Emk1gfXCCA2ktD5xOh871aNgpyVWpZJbDsLKCpI3P7/rmDEfWbgxO1ohk9dcWRVE0BSTHWRtsAkhyngsyxkwDyUE8FUUeYw+kjVikBye5Tuwh2l7Pgy8g6eWPwDwiUXfy/SW9c4UDyaHVZ2AtI+ntRODpYJa1uBhZ78cQiLxxw/f9mbzJ+d651jyXgP5urALxCPfqWFtI0rSCjDFzyHIKJJ1sIVhEgOQlqSl8IpC1PuotgYFdQPoKpHuIupT5f7QAsLTTAgGXN9Pr1Wp1FkmfgWTf0mDhDiy3VYZ2IctZGFYW+w1pq/imp6y2TglLO6kJgmB+WE/SLJww1ptiAdIT67bHsijT0eBM6vF0/YmAa0xegKT5xfNBfACal83ImIPmvwAAAABJRU5ErkJggg==)
 */
export const ActivitiesPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M22 4v1.51a6 6 0 0 1-1.76 4.25l-4.1 4.1a.5.5 0 0 0-.14.35v1.29a.5.5 0 0 1-.5.5H15a3 3 0 0 0-3 3c0 .21-.3.26-.36.07l-.8-2.17a.5.5 0 0 0-.12-.18l-3.46-3.46a.5.5 0 0 0-.17-.11l-4.8-1.85a.5.5 0 0 1-.15-.85l2.02-1.73A3 3 0 0 1 6.1 8h3.68a.5.5 0 0 0 .36-.15l4.1-4.1A6 6 0 0 1 18.48 2H20a2 2 0 0 1 2 2Zm-5 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9 19a1 1 0 0 0-1-1H7a1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1 3 3 0 0 0-3 3v3a1 1 0 0 0 1 1h3a3 3 0 0 0 3-3ZM19 14a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
